import { hubShiftsIntlIds } from './hub-shifts.ids';

export const hubShiftsLangPtBr = {
  [hubShiftsIntlIds.hubShiftsList.table.cell.header.date]: 'Data',
  [hubShiftsIntlIds.hubShiftsList.table.cell.header.shift]: 'Turno',
  [hubShiftsIntlIds.hubShiftsList.table.cell.header.assignRider]: 'Atribuir',
  [hubShiftsIntlIds.hubShiftsList.table.cell.body.shift]:
    '{startTime} às {endTime}',

  [hubShiftsIntlIds.assignRiderToHubShiftModal.trigger.openModalButton.label]:
    'Atribuir Rider',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.header.title]:
    'Confirma atribuição da pessoa Rider? ',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.header.closeIconButton.label]:
    'Fechar',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.body.description]:
    'Ao confirmar, uma vaga do <highlight>turno {shiftName}, no dia {shiftDate}, das {shiftStartsAt} às {shiftEndsAt}</highlight>, será automaticamente atribuída à pessoa Rider selecionada.',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.body.reviewBeforeConfirming]:
    'Revise antes de confirmar.',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.body.selectRider.placeholder]:
    'Selecione ou busque pelo Rider ID',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.body.selectRider
    .label]: `ID {riderId}: {riderName} • {medal, select,
      gold {Ouro}
      silver {Prata}
      bronze {Bronze}
      other {}
    } • {modality, select,
      bicycle {Bike}
      motorcycle {Moto}
      other {}
    }`,
  [hubShiftsIntlIds.assignRiderToHubShiftModal.body.selectRider
    .noRidersAvailable.label]: 'Sem Riders disponíveis',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.body.errors.allSlotsTaken.label]:
    '<highlight>Período esgotado!</highlight> Todas as vagas deste período já foram reservadas, para concluir a atribuição, escolha outro turno',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.body.errors.overlappingBooking
    .label]:
    'A pessoa já tem uma vaga confirmada no <highlight>turno {shiftName} ({shiftStartsAt} às {shiftEndsAt})</highlight>, que conflita com esta. Escolha outro turno para evitar conflitos',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.footer.cancelButton.label]:
    'Cancelar',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.footer.confirmAndAssignButton
    .label]: 'Confirmar e atribuir',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.toasts.onSuccess.title]:
    'Atribuição da vaga realizada com sucesso! ',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.toasts.onSuccess.description]:
    'A pessoa Rider será notificada sobre a alteração',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.toasts.onError.title]:
    'Erro ao atribuir a vaga!',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.toasts.onError.description]:
    'Por favor, tente novamente',
};
